import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';

import { FooterContainer } from './MinimalFooterComponentStyle';

class MinimalFooterComponent extends React.Component {
    showCmp() {
        window.Didomi.preferences.show();
    }

    render() {
        const { i18n } = this.props;
        return (
            <FooterContainer>
                <div className="conteneur conteneur-mobile">
                    <ul>
                        <li>
                            <span className="link" onClick={this.showCmp}>
                                {i18n.LINKS.CONSENT_CHOICES}
                            </span>
                        </li>
                    </ul>
                </div>
            </FooterContainer>
        );
    }
}

MinimalFooterComponent.propTypes = {
    i18n: PropTypes.object.isRequired
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.FOOTER
    };
};

export default connect(mapStateToProps)(MinimalFooterComponent);



// WEBPACK FOOTER //
// ./src/components/footer/minimal/MinimalFooterComponent.js